import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
// eslint-disable-next-line no-restricted-imports -- Augmenting and forwarding MUI component
import { Typography as MuiTypography } from '@mui/material';
export const Typography = /*#__PURE__*/ forwardRef(function Typography(props, ref) {
    // Only assign a default component if one is not set by the caller
    if (props.component === undefined) {
        // If no variant is provided, default to a 'div' tag because 'p' tags can't be nested inside themselves
        if (props.variant === undefined) {
            return /*#__PURE__*/ _jsx(MuiTypography, {
                component: "div",
                ref: ref,
                ...props
            });
        }
        // For body variants, use a 'div' tag instead of 'p' to avoid accidental invalid DOM nesting
        if (props.variant?.startsWith('body')) {
            return /*#__PURE__*/ _jsx(MuiTypography, {
                component: "div",
                ref: ref,
                ...props
            });
        }
        // For inline variants, use a 'span' tag instead of 'p' to avoid accidental invalid DOM nesting
        if (props.variant && [
            'caption',
            'code',
            'button',
            'overline1',
            'overline2'
        ].includes(props.variant)) {
            return /*#__PURE__*/ _jsx(MuiTypography, {
                component: "span",
                ref: ref,
                ...props
            });
        }
    }
    return /*#__PURE__*/ _jsx(MuiTypography, {
        ref: ref,
        ...props
    });
});

//# sourceMappingURL=Typography.js.map